import { css, CSSResult } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  .csc-filter-wizard {
    --cse-paper-gap: ${csSpacing.spacing06};
  }

  @media(max-width: ${SCREENS.medium}) {
    .filter-options {
      --cse-selectable-group-grid-template-columns: repeat(2, 1fr);
    }
  }

  @media(min-width: ${SCREENS.medium}) {
    .filter-options {
      --cse-selectable-group-grid-template-columns: repeat(3, 1fr);
    }
  }

  @media(min-width: ${SCREENS.large}) {
    .filter-options {
      --cse-selectable-group-grid-template-columns: repeat(4, 1fr);
    }
  }
`
